import { I as i } from "../../constants-DeVuDy8J.js";
import { openBlock as d, createElementBlock as l, normalizeClass as s, createElementVNode as n } from "vue";
import { _ as o } from "../../_plugin-vue_export-helper-CHgC5LLL.js";
const c = {
  name: "DtIconDigitalWhisper",
  props: {
    /**
     * The size of the icon.
     * @values 100, 200, 300, 400, 500, 600, 700, 800
     */
    size: {
      type: String,
      default: "500",
      validator: (e) => Object.keys(i).includes(e)
    },
    /**
     * The label of the icon as read out by a screenreader. Leave this unset if your icon is purely presentational
     */
    ariaLabel: {
      type: String,
      default: void 0
    }
  },
  /**
  * @TODO: Remove this emit once the icons migration is complete,
  * they will no longer need this event.
  * */
  emits: ["loaded"],
  computed: {
    iconSizeClass() {
      return i[this.size];
    },
    ariaHidden() {
      return this.ariaLabel ? "false" : "true";
    },
    dataQA() {
      return this.$attrs["data-qa"] ?? "dt-icon";
    }
  },
  created() {
    this.$emit("loaded");
  }
}, m = ["aria-label", "data-qa", "aria-hidden"];
function h(e, t, r, _, p, a) {
  return d(), l("svg", {
    "aria-label": r.ariaLabel,
    class: s([a.iconSizeClass, "d-icon d-icon--digital-whisper"]),
    "data-qa": a.dataQA,
    "aria-hidden": a.ariaHidden,
    role: "img",
    "data-name": "Digital Whisper",
    viewBox: "0 0 12 12",
    xmlns: "http://www.w3.org/2000/svg"
  }, [...t[0] || (t[0] = [
    n("path", {
      d: "M2.146 10.146a.5.5 0 1 1 .708.707l-1 1A.5.5 0 0 1 1 11.5v-1a.5.5 0 0 1 .967-.175l.18-.178ZM5.25 9a.5.5 0 0 1 0 1h-1a.5.5 0 0 1 0-1h1Zm2.5 0a.5.5 0 0 1 0 1h-1a.5.5 0 0 1 0-1h1ZM10 8.5a.5.5 0 0 1 1 0A1.5 1.5 0 0 1 9.5 10a.5.5 0 0 1 0-1 .5.5 0 0 0 .5-.5ZM1 9V8a.5.5 0 0 1 1 0v1a.5.5 0 0 1-1 0Zm0-2.75v-1a.5.5 0 0 1 1 0v1a.5.5 0 0 1-1 0Zm9 0v-1a.5.5 0 0 1 1 0v1a.5.5 0 0 1-1 0ZM1 3.5A1.5 1.5 0 0 1 2.5 2a.5.5 0 0 1 0 1 .5.5 0 0 0-.5.5.5.5 0 0 1-1 0Zm9 0a.5.5 0 0 0-.5-.5.5.5 0 0 1 0-1A1.5 1.5 0 0 1 11 3.5a.5.5 0 0 1-1 0ZM5.25 2a.5.5 0 0 1 0 1h-1a.5.5 0 0 1 0-1h1Zm2.5 0a.5.5 0 0 1 0 1h-1a.5.5 0 0 1 0-1h1Z",
      fill: "currentColor"
    }, null, -1)
  ])], 10, m);
}
const v = /* @__PURE__ */ o(c, [["render", h]]);
export {
  v as default
};
//# sourceMappingURL=digital-whisper.js.map
